export function mapInputsErrors(
  emailError: string | undefined,
  passwordError: string | undefined,
) {
  const errors = [];

  if (emailError) {
    errors.push("WrongEmail");
  }

  if (passwordError) {
    errors.push("WrongPassword");
  }

  return errors.join(", ");
}
